module.exports = __webpack_public_path__ + "img/img01-@2x.93241ebb.webp";